<template>
  <div class="login-form login-signin2">
    <form class="form" novalidate="novalidate" id="kt_login_signin2_form">
      <div class="pb-13 pt-lg-0 pt-5">
        <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
          {{ $t("login.welcome") }}
        </h3>
        <span class="text-muted font-weight-bold font-size-h4">
          {{ $t("login.access") }}
        </span>
      </div>
      <div class="form-group">
        <div class="d-flex justify-content-between mt-n5">
          <label class="font-size-h6 font-weight-bolder text-dark pt-5">{{
            $t("login.password")
          }}</label>
          <a
            class="
              text-primary
              font-size-h6 font-weight-bolder
              text-hover-primary
              pt-5
            "
            id="kt_login_forgot"
            @click="$emit('showForm', 'forgot')"
          >
            {{ $t("login.forgot") }}
          </a>
        </div>
        <div id="example-input-group-2" label="" label-for="example-input-2">
          <input
            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
            type="password"
            name="password"
            ref="password"
            v-model="form.password"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="d-flex align-center justify-left">
        <v-btn @click="goBack" class="pb-lg-0 pb-5 mr-5">
          <v-icon>fas fa-arrow-left</v-icon>
        </v-btn>
        <div class="pb-lg-0 pb-5">
          <button
            ref="kt_login_signin2_submit"
            class="
              btn btn-primary
              font-weight-bolder font-size-h6
              px-15
              py-4
              my-3
              mr-3
            "
          >
            {{ $t("login.signIn") }}
          </button>
        </div>
      </div>
      <div
        role="alert"
        v-bind:class="{ show: errors.length }"
        class="alert fade alert-danger"
      >
        <div class="alert-text" v-for="(error, i) in errors" :key="i">
          {{ error.message }}
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import KTUtil from "@/assets/js/components/util";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { LOGIN, LOGOUT_NO_REDIRECT } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

export default {
  name: "signInForm",
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
  },
  methods: {
    goBack() {
      this.$store.dispatch(LOGOUT_NO_REDIRECT);
      this.$emit("showForm", "signin1");
    },
  },
  mounted() {
    const signin_form = KTUtil.getById("kt_login_signin2_form");
    this.form.email = localStorage.getItem('auth_email');
    this.fv = formValidation(signin_form, {
      fields: {
        password: {
          validators: {
            notEmpty: {
              message: this.$i18n.t("login.passwordRequired"),
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv.on("core.form.valid", () => {
      const email = this.form.email;
      const password = this.form.password;

      // clear existing errors
      this.$store.dispatch(LOGOUT_NO_REDIRECT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin2_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      this.$store
        .dispatch(LOGIN, { email, password })
        // go to which page after successfully login
        .then(() => this.$router.push({ name: "tableauDeBord" }))
        .catch((error) => console.log(error))
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    });

    this.fv.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: this.$i18n.t("login.incorrectData"),
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false,
      });
    });

    // initialisation des localStorage après chaque connexion
    const currentLanguage = localStorage.getItem("language");
    localStorage.clear();
    if (currentLanguage) {
      localStorage.setItem("language", currentLanguage);
    }
  },
};
</script>
